import { FC } from 'react'
import { ActionButtonProps } from 'src/components/ActionButton'

import * as SC from './styled'

export type NotFoundTemplateProps = {
  title: string
  text: string
  button: ActionButtonProps
}

const NotFoundTemplate: FC<NotFoundTemplateProps> = ({
  title,
  button,
  text,
}) => {
  return (
    <SC.Layout>
      <SC.Wrapper>
        <SC.Title>{title}</SC.Title>
        <SC.Text>{text}</SC.Text>
        <SC.Button {...button} />
      </SC.Wrapper>
    </SC.Layout>
  )
}

export default NotFoundTemplate
